import React from "react";
import Header from '../Component/Header';
import { useState,useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import AdminService from "../Services/AdminService";

const CompanyProfile=()=>{
    const token = localStorage.getItem("JWTToken");
    const [CompanyData,SetCompanyData]=useState([])
    const navigate = useNavigate();
  
    useEffect(() => {
        if (token) {
            const GetCompanyData = async () => {
                try {
                    const response = await AdminService.GetUserCompanyDetails(token);
                    if (response) {
                        console.log(response.RESPONSE);
                        SetCompanyData(response.RESPONSE[0]);
                    }
                } catch (error) {

                }
            }
          
            GetCompanyData();
        } else {
            navigate("/Login");
        }
    }, [token]);
    const formatDate = (date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Add 1 because getMonth() is zero-based
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };
    const parseDateString = (dateString) => {
        const parsedDate = new Date(dateString); // Convert to Date object
        if (isNaN(parsedDate)) {
            console.error(`Invalid date string: ${dateString}`);
            return null; // Return null if invalid
        }
        return parsedDate;
    };
    return (<>
        <Header />
        <div className="min-hight75vh bg-grey">
            <div className="py-5 container">
                <h4 className="fw-bold">Account and Settings</h4>

                <div className="mt-5 nav-tabs">
                    <div className="row mb-4">
                        <div className="col-4">
                            <h4 className="TruveyColor fw-bold">Logo</h4>
                        </div>
                        <div className="col-6">
                            <div className="CompanyLogoSet p-1">
                                <img src={CompanyData.CompanyLogo} alt="Company Logo..." className="w-100 h-100" />
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-4">
                            <h4 className="TruveyColor fw-bold">Basic info</h4>
                        </div>
                        <div className="col-6">
                                <div className="row mb-3">
                                    <div className="col-4"><label className="nav-link p-2 fs-14 br-none">Company Name</label></div>
                                    <div className="col-6"><label className="nav-link p-2 fs-14 br-none border bg-white text-black">{CompanyData.CompanyName}</label></div>
                                </div>
                                <div className="row mb-3">
                                    <div className="col-4"><label className="nav-link p-2 fs-14 br-none">Company ID</label></div>
                                    <div className="col-6"><label className="nav-link p-2 fs-14 br-none border bg-white text-black">{CompanyData.CompanyUID ? CompanyData.CompanyUID : "Null"}</label></div>
                                </div>
                                <div className="row mb-3">
                                    <div className="col-4"><label className="nav-link p-2 fs-14 br-none">State</label></div>
                                    <div className="col-6"><label className="nav-link p-2 fs-14 br-none border bg-white text-black">{CompanyData.State ? CompanyData.State : "Null"}</label></div>
                                </div>
                                <div className="row mb-3">
                                    <div className="col-4"><label className="nav-link p-2 fs-14 br-none">Country</label></div>
                                    <div className="col-6"><label className="nav-link p-2 fs-14 br-none border bg-white text-black">{CompanyData.Country ? CompanyData.Country : "Null"}</label></div>
                                </div>
                                <div className="row mb-3">
                                    <div className="col-4"><label className="nav-link p-2 fs-14 br-none">City</label></div>
                                    <div className="col-6"><label className="nav-link p-2 fs-14 br-none border bg-white text-black">{CompanyData.City ? CompanyData.City : "Null"}</label></div>
                                </div>
                                <div className="row mb-3">
                                    <div className="col-4"><label className="nav-link p-2 fs-14 br-none">Postal Code</label></div>
                                    <div className="col-6"><label className="nav-link p-2 fs-14 br-none border bg-white text-black">{CompanyData.PostalCode ? CompanyData.PostalCode : "Null"}</label></div>
                                </div>
                                <div className="row mb-3">
                                    <div className="col-4"><label className="nav-link p-2 fs-14 br-none">Address</label></div>
                                    <div className="col-6"><label className="nav-link p-2 fs-14 br-none border bg-white text-black">{CompanyData.Address ? CompanyData.Address : "Null"}</label></div>
                                </div>
                                <div className="row mb-3">
                                    <div className="col-4"><label className="nav-link p-2 fs-14 br-none">EstablishmentDate</label></div>
                                <div className="col-6">
                                    <label className="nav-link p-2 fs-14 br-none border bg-white text-black">
                                        {CompanyData.EstablishmentDate ? formatDate(parseDateString(CompanyData.EstablishmentDate)) : "Null"}
                                    </label>
                                </div>
                                </div>
                                <div className="row mb-3">
                                    <div className="col-4"><label className="nav-link p-2 fs-14 br-none">ParentCompany</label></div>
                                    <div className="col-6"><label className="nav-link p-2 fs-14 br-none border bg-white text-black">{CompanyData.ParentCompany ? CompanyData.ParentCompany : "Null"}</label></div>
                                </div>
                                <div className="row mb-3">
                                    <div className="col-4"><label className="nav-link p-2 fs-14 br-none">Subsidiaries</label></div>
                                    <div className="col-6"><label className="nav-link p-2 fs-14 br-none border bg-white text-black">{CompanyData.Subsidiaries ? CompanyData.Subsidiaries : "Null"}</label></div>
                                </div>
                                <div className="row mb-3">
                                    <div className="col-4"><label className="nav-link p-2 fs-14 br-none">WebsiteURL</label></div>
                                    <div className="col-6"><label className="nav-link p-2 fs-14 br-none border bg-white text-black">{CompanyData.WebsiteURL ? CompanyData.WebsiteURL : "Null" }</label></div>
                                </div>
                        </div>

                    </div>
                    
                </div>
            </div>
        </div>
</>)
}
export default CompanyProfile;